import { component } from 'picoapp';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const btn = node.querySelector('.js-btn');
  const content = node.querySelector('.js-content');

  /**
   * Functions
   */
  const toggle = (node) => {
    const anchorTarget = node.getAttribute('data-anchor-target');
    if (anchorTarget !== null && anchorTarget !== "" && anchorTarget !== undefined) {
      redirectToTargetSection(anchorTarget);
      return;
    }

    btn.classList.toggle('harmonica-item__button--active');

    if (content.hidden) {
      content.hidden = false;
    } else {
      content.hidden = true;
    }
  };

  const redirectToTargetSection = (anchorTarget) => {
    window.location.href = `#${anchorTarget}`;
    setTimeout(() => {
        history.replaceState(null, null, ' ');
        const element = document.querySelector(`[data-id="${anchorTarget}"]`);
        if (element) {
            const yOffset = -85;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }, 0);
  }

  const init = () => {
    btn.addEventListener('click',() => toggle(node));
  };

  /**
   * Init
   */
  init();
});
